export const COUNTERPARTIES_TESTIDS = {
  addButton: "add-counterparty-button",
  nameInput: "counterparty-name-input",
  innInput: "counterparty-inn-input",
  saveButton: "counterparty-save-button",
  searchInput: "counterparty-search-input",
};
